import { ErrorMessage, FieldArray, Form, Field } from "formik";
import React, { Fragment } from "react";
import {
    Button,
    FormGroup,
    FormLabel,
    FormText,
    Spinner,
} from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import FormListSingleFieldItem from "src/components/Shared/SharedFormComponents/FormListSingleFieldItem";
import styles from "../RetailerSettings.module.scss";
import "react-phone-input-2/lib/style.css";
import FormListButton from "src/components/Shared/SharedFormComponents/FormListButton";
import { GoogleLogin } from "@react-oauth/google";

const SettingsLocationsFormView = ({
    handleSubmit,
    values,
    isSubmitting,
    currentLocation,
    setFieldValue,
    calendars,
    connectedCalendarInfo,
    login,
    externalCalendarSyncEnabled,
}) => {
    console.log("SettingsLocationsFormView", values)
    return (
        <Form onSubmit={handleSubmit} className={styles.RetailerSettings}>
            <FormGroup controlId="input-email">
                <FormLabel>Email addresses</FormLabel>
                <FieldArray
                    name="additionalEmails"
                    render={(arrayHelpers) => {
                        return (
                            <>
                                <FormListSingleFieldItem
                                    type={"email"}
                                    placeholder={"Email"}
                                    name={"email"}
                                    buttonText={"Add Email"}
                                    buttonOnClick={() => arrayHelpers.push("")}
                                />

                                {values.additionalEmails.map((_, i) => {
                                    return (
                                        <FormListSingleFieldItem
                                            key={i}
                                            placeholder={"Email"}
                                            type={"email"}
                                            name={`additionalEmails[${i}]`}
                                            buttonText={"x"}
                                            buttonOnClick={() =>
                                                arrayHelpers.remove(i)
                                            }
                                        />
                                    );
                                })}
                            </>
                        );
                    }}
                />
                <FormText muted>
                    Confirmation emails and calendar invites will be sent to
                    these email addresses for appointments at ONLY this
                    location.
                </FormText>
            </FormGroup>
            <FormGroup>
                <FormLabel>Phone Numbers</FormLabel>
                <FieldArray
                    name="phoneNumbers"
                    render={(arrayHelpers) => {
                        return (
                            <>
                                <div className={styles.PhoneFieldContainer}>
                                    <PhoneInput
                                        containerClass={styles.PhoneNumberField}
                                        inputClass={styles.PhoneFieldInput}
                                        country={"us"}
                                        enableAreaCodes={true}
                                        enableAreaCodeStretch={true}
                                        value={values.phoneNumber}
                                        onChange={(phone) =>
                                            setFieldValue("phoneNumber", phone)
                                        }
                                    />
                                    <FormListButton
                                        className={styles.addNumberField}
                                        text={"Add Phone Number"}
                                        onClick={() => arrayHelpers.push("")}
                                    />
                                </div>
                                <ErrorMessage
                                    className="error-message"
                                    component="div"
                                    name={"phoneNumber"}
                                />

                                {values.phoneNumbers.map((_, i) => {
                                    return (
                                        <Fragment key={i}>
                                            <div
                                                className={
                                                    styles.PhoneFieldContainer
                                                }
                                            >
                                                <PhoneInput
                                                    containerClass={
                                                        styles.PhoneNumberField
                                                    }
                                                    inputClass={
                                                        styles.PhoneFieldInput
                                                    }
                                                    country={"us"}
                                                    enableAreaCodes={true}
                                                    enableAreaCodeStretch={true}
                                                    value={
                                                        values.phoneNumbers[i]
                                                    }
                                                    onChange={(phone) =>
                                                        setFieldValue(
                                                            `phoneNumbers[${i}]`,
                                                            phone
                                                        )
                                                    }
                                                />
                                                <FormListButton
                                                    text={"x"}
                                                    onClick={() =>
                                                        arrayHelpers.remove(i)
                                                    }
                                                />
                                            </div>
                                            <ErrorMessage
                                                className="error-message"
                                                component="div"
                                                name={"phoneNumber"}
                                            />
                                        </Fragment>
                                    );
                                })}
                            </>
                        );
                    }}
                />
                <FormText muted>
                    Text message confirmations will be sent to any numbers
                    listed above for appointments at ONLY this location.
                </FormText>
            </FormGroup>

            {/* {currentLocation.locationSignupId && (
                <>
                    <p>Location Signup Link</p>
                    <p>
                        You can give this link to managers or associates if you
                        want them to have access only to this specific location.
                        They cannot adjust settings or see other calendars.
                    </p>
                    <p>
                        <a
                            href={`${CONFIG.appUrl}/register-retailer?signupCode=${currentLocation.locationSignupId}`}
                        >
                            {CONFIG.appUrl}/register-retailer?signupCode=
                            {currentLocation.locationSignupId}
                        </a>
                    </p>
                </>
            )} */}

            {!!externalCalendarSyncEnabled && (
                <Fragment>
                    <h3 style={{ marginTop: "20px" }}>
                        Sync a Google Calendar
                    </h3>

                    <div
                        className={styles.googleLoginContainer}
                        onClick={() => login()}
                    >
                        <div style={{ pointerEvents: "none" }}>
                            <GoogleLogin
                                ux_mode="popup"
                                onSuccess={() => { }}
                                onError={() => { }}
                            ></GoogleLogin>
                        </div>
                    </div>
                    {calendars.length || connectedCalendarInfo ? (
                        <Fragment>
                            <h3>Choose Calendar To Sync</h3>
                            <p>
                                Click below to sync an outside Google Calendar
                                with this location
                            </p>
                            {connectedCalendarInfo ? (
                                <FormText muted>
                                    {connectedCalendarInfo}
                                </FormText>
                            ) : null}
                            <div className="radioToggleGroup">
                                {calendars.map((calendar) => {
                                    return (
                                        <Fragment key={calendar.id}>
                                            <input
                                                type="checkbox"
                                                id={`input-calendar-${calendar.id}`}
                                                name="selectedCalendars"
                                                value={calendar.id}
                                                autoComplete="off"
                                                onChange={() => {
                                                    if (
                                                        values.selectedCalendars ===
                                                        calendar.id
                                                    ) {
                                                        setFieldValue(
                                                            "selectedCalendars",
                                                            ""
                                                        );
                                                    } else {
                                                        setFieldValue(
                                                            "selectedCalendars",
                                                            calendar.id
                                                        );
                                                    }
                                                }}
                                                checked={
                                                    values.selectedCalendars ===
                                                    calendar.id
                                                }
                                            />
                                            <label
                                                htmlFor={`input-calendar-${calendar.id}`}
                                                style={{ width: "100%" }}
                                            >
                                                {calendar.summary}
                                            </label>
                                        </Fragment>
                                    );
                                })}
                            </div>
                        </Fragment>
                    ) : null}
                </Fragment>
            )}

            <Button type="submit" disabled={isSubmitting}>
                {isSubmitting ? (
                    <Spinner animation="border" size="sm" />
                ) : (
                    "Save"
                )}
            </Button>
        </Form>
    );
};

export default SettingsLocationsFormView;
